<template lang="pug">
.map-header
  .uk-flex.uk-flex-center.uk-flex-middle
    div
      a.offcanvas-button(
        href="#offcanvas",
        :class="{'is-open' : offcanvas_is_show}",
        @click.prevent="handleToggleOffcanvas"
      )
        div
          svg(width="48px", height="24px", viewBox="0 0 48 48", version="1.1", xmlns="http://www.w3.org/2000/svg")
            g
              line(x1="0", y1="17", x2="60", y2="17", stroke-width="3")
              line(x1="0", y1="31", x2="60", y2="31", stroke-width="3")
            g
              line(x1="0", y1="24", x2="48", y2="24", stroke-width="3")
              line(x1="0", y1="24", x2="48", y2="24", stroke-width="3")
        span.uk-text-center(v-if="!offcanvas_is_show") メニュー
        span.uk-text-center(v-else) 閉じる

    div
      img(:src="logo_url", alt="横手市ハザードマップ", loading="lazy", width="30")
    div &nbsp;横手市ハザードマップ

</template>

<script>
import * as types from "../js/mutations/map-mutations"

export default {
  computed: {
    logo_url () {
      return `${baseUrl}/assets/common/logo.png`
    },
    menu_logo_url () {
      return `${baseUrl}/assets/common/menu.png`
    },
    offcanvas_is_show () { return this.$store.getters.offcanvas_is_show },
  },
  methods: {
    handleToggleOffcanvas () {
      this.$store.dispatch(types.TOGGLE_OFFCANVAS)
    },
  }
}
</script>
